module.exports = __webpack_public_path__ + "static/sides-ef23962fd316fed9cb8f938f692529ad.png";